import { render, staticRenderFns } from "./SafetyProgramEdit.vue?vue&type=template&id=20e1b83d"
import script from "./SafetyProgramEdit.vue?vue&type=script&lang=js"
export * from "./SafetyProgramEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports